import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "grid grid-cols-1 md:grid-cols-2 gap-y-8 gap-x-4 mb-8"
}
const _hoisted_2 = { class: "col" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, "Start Weights", -1)
const _hoisted_4 = { class: "flex mt-4 mb-1 mr-3" }
const _hoisted_5 = { class: "flex-1" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" End Weights ")
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "flex mt-4 mb-1 mr-3" }
const _hoisted_10 = { class: "flex-1" }
const _hoisted_11 = { class: "" }

import BalRangeInput from '@/components/_global/BalRangeInput/BalRangeInput.vue';
import BalTooltip from '@/components/_global/BalTooltip/BalTooltip.vue';
import BalIcon from '@/components/_global/BalIcon/BalIcon.vue';
import LbpTokenWeightRangeLabel from '@/embr/lbp/components/LbpTokenWeightRangeLabel.vue';
import useLgeCreateState from '@/embr/lbp/composables/useLgeCreateState';
import useTokens from '@/composables/useTokens';
import { computed } from 'vue';
import LbpPreviewChart from '@/embr/lbp/components/LbpPreviewChart.vue';


export default _defineComponent({
  setup(__props) {

const { data, lgeChartConfigValid } = useLgeCreateState();
const { tokens, getToken, dynamicDataLoaded, dynamicDataLoading } = useTokens();

const launchToken = computed(() => {
  return getToken(data.value.tokenContractAddress);
});

const collateralToken = computed(() => {
  return getToken(data.value.collateralTokenAddress);
});

function handleStartWeightChange() {
  data.value.collateralStartWeight = 100 - data.value.tokenStartWeight;
}

function handleEndWeightChange() {
  data.value.collateralEndWeight = 100 - data.value.tokenEndWeight;
}

return (_ctx: any,_cache: any) => {
  const _component_BalAlert = _resolveComponent("BalAlert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(dynamicDataLoading) && _unref(launchToken) && _unref(collateralToken))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(LbpTokenWeightRangeLabel, {
                  address: _unref(data).tokenContractAddress,
                  symbol: _unref(launchToken)?.symbol || '',
                  weight: _unref(data).tokenStartWeight / 100,
                  iconURI: _unref(data).tokenIconUrl
                }, null, 8, ["address", "symbol", "weight", "iconURI"])
              ]),
              _createVNode(LbpTokenWeightRangeLabel, {
                address: _unref(data).collateralTokenAddress,
                symbol: _unref(collateralToken)?.symbol || '',
                weight: _unref(data).collateralStartWeight / 100
              }, null, 8, ["address", "symbol", "weight"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(BalRangeInput, {
                class: "w-full",
                modelValue: _unref(data).tokenStartWeight,
                "onUpdate:modelValue": [
                  _cache[0] || (_cache[0] = ($event: any) => (_unref(data).tokenStartWeight = $event)),
                  handleStartWeightChange
                ],
                max: 99,
                interval: 1,
                min: 1
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", null, [
              _hoisted_7,
              _createVNode(BalTooltip, null, {
                activator: _withCtx(() => [
                  _createVNode(BalIcon, {
                    name: "info",
                    size: "sm",
                    class: "ml-1 text-gray-400 -mb-px"
                  })
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    innerHTML: _ctx.abc,
                    class: "w-52"
                  }, null, 8, _hoisted_8)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(LbpTokenWeightRangeLabel, {
                  address: _unref(data).tokenContractAddress,
                  symbol: _unref(launchToken)?.symbol || '',
                  weight: _unref(data).tokenEndWeight / 100,
                  iconURI: _unref(data).tokenIconUrl
                }, null, 8, ["address", "symbol", "weight", "iconURI"])
              ]),
              _createVNode(LbpTokenWeightRangeLabel, {
                address: _unref(data).collateralTokenAddress,
                symbol: _unref(collateralToken)?.symbol || '',
                weight: _unref(data).collateralEndWeight / 100
              }, null, 8, ["address", "symbol", "weight"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(BalRangeInput, {
                class: "w-full",
                modelValue: _unref(data).tokenEndWeight,
                "onUpdate:modelValue": [
                  _cache[1] || (_cache[1] = ($event: any) => (_unref(data).tokenEndWeight = $event)),
                  handleEndWeightChange
                ],
                max: 99,
                interval: 1,
                min: 1
              }, null, 8, ["modelValue"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(lgeChartConfigValid) !== true)
      ? (_openBlock(), _createBlock(_component_BalAlert, {
          key: 1,
          title: _unref(lgeChartConfigValid),
          class: "w-full mb-8",
          type: "error"
        }, null, 8, ["title"]))
      : _createCommentVNode("", true),
    _createVNode(LbpPreviewChart)
  ], 64))
}
}

})